import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';

@Component({
    selector: 'kaz-imprint',
    templateUrl: './imprint.component.html',
    styleUrls: ['./imprint.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent]
})
export class ImprintComponent {

}
